import React from 'react';
import {
	ToolbarSkeleton,
	type SkeletonToolbarProps,
} from '@atlassian/jira-floating-toolbar/src/ui/skeleton/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { messages as changeStatusMessages } from '../change-status-button/messages.tsx';
import { messages as editButtonMessages } from '../edit-button/messages.tsx';

export const BulkOperationsToolbarSkeleton = ({
	hasSelectAllButton,
	buttons,
}: SkeletonToolbarProps) => {
	const { formatMessage } = useIntl();

	const allButtons: SkeletonToolbarProps['buttons'] = [
		{
			text: formatMessage(editButtonMessages.editFields),
			hasIcon: true,
		},
		{
			text: formatMessage(changeStatusMessages.changeStatus),
			hasIcon: true,
		},
		...buttons,
	];

	return <ToolbarSkeleton hasSelectAllButton={hasSelectAllButton} buttons={allButtons} />;
};
